import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CollectionsList.styled';
import { CollectionsListSkeleton } from './CollectionsListSkeleton';
import { BookmarkCollection } from '@/features/BookmarkCollections/api';

interface CollectionsListProps {
  loading: boolean;
  selected: string[];
  collections: BookmarkCollection[];
  handleAddToCollection: (id: string) => void;
}

export const CollectionsList = React.forwardRef<
  HTMLDivElement,
  CollectionsListProps
>(({ loading, collections, selected, handleAddToCollection }, ref) => {
  const { t } = useTranslation();

  return (
    <S.List ref={ref} data-testid="collections-list">
      {loading ? (
        <CollectionsListSkeleton />
      ) : (
        collections.map(item => {
          const isSelected = selected?.includes(item.id);

          return (
            <S.Item
              $isSelectable
              key={item.id}
              $isSelected={isSelected}
              onClick={() => handleAddToCollection(item.id)}
              data-testid="collections-list-item"
            >
              <S.Image $image={item.photos.at(0)?.url} />
              <S.ItemInfo>
                <S.ItemTitle>{item.name}</S.ItemTitle>
                <S.ItemCount>
                  {t('bookmark_collections.item_ad_count', {
                    count: item.ads.totalCount,
                  })}
                </S.ItemCount>
              </S.ItemInfo>
              <S.Checkbox $isChecked={isSelected} />
            </S.Item>
          );
        })
      )}
    </S.List>
  );
});

CollectionsList.displayName = 'CollectionsList';
